import { Component } from '@angular/core';
import { IonicPage, NavController,LoadingController, NavParams,ViewController } from 'ionic-angular';

/**
 * Generated class for the FileuploadPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-fileupload',
  templateUrl: 'fileupload.html',
})
export class FileuploadPage {

  constructor(public loadingCtrl: LoadingController,public viewCtrl : ViewController,public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    //console.log('ionViewDidLoad FileuploadPage');
  }
 async fileUpload(event){
 const loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    // loading.present();
  console.log(JSON.stringify(event[0]));
   var data =  await this.toBase64(event[0])
   // var newImage = await this.resizeBase64Img(loading,data, 40, 40);
   //console.log("new image uploaded",newImage);
   let detailsObject:any={}
   
   detailsObject.document = event[0];
   detailsObject.data = data;
    this.viewCtrl.dismiss(detailsObject)
  }
  // const toBase64 = file =>
 async toBase64(file){
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = reject;
        });
 }
 async resizeBase64Img(loading,base64, newWidth, newHeight) {
  
  return new Promise((resolve, reject) => {
    
    var canvas = document.createElement("canvas");
    canvas.style.width = newWidth.toString() + "px";
    canvas.style.height = newHeight.toString() + "px";
    let context = canvas.getContext("2d");
    let img = document.createElement("img");
    img.src = base64;
    loading.dismiss();
    img.onload = function() {
      context.scale(newWidth / img.width, newHeight / img.height);
      context.drawImage(img, 0, 0);
      
      resolve(canvas.toDataURL());
    }
  });
} 
dismiss() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/fileupload/fileupload.ts